"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ThumbConnectorElement = exports.TrackOverlayElement = exports.IncrementLabelElement = exports.ThumbLabelElement = exports.ThumbElement = exports.TrackElement = exports.TrackWrapperElement = exports.RangeWraperElement = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("../../styled"));

var _polished = require("polished");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var THUMB_DIAMETER = 16;
var TRACK_THICKNESS = 4;
var SINGLE_VALUE_KEY = '_SINGLE_VALE';

var RangeWraperElement = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 400px;\n  pointer-events: ", ";\n"])), function (_ref) {
  var disableMouseEvents = _ref.disableMouseEvents;
  return disableMouseEvents ? 'none' : 'all';
});

exports.RangeWraperElement = RangeWraperElement;

var TrackWrapperElement = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: calc(100% - ", "px);\n  margin: 0 0.5rem;\n  overflow: visible;\n"])), THUMB_DIAMETER);

exports.TrackWrapperElement = TrackWrapperElement;

var TrackElement = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  margin: ", "px 0;\n  height: ", "px;\n  width: 100%;\n  border-radius: ", "px;\n  background-color: ", ";\n"])), (THUMB_DIAMETER - TRACK_THICKNESS) / 2, TRACK_THICKNESS, TRACK_THICKNESS / 2, function (_ref2) {
  var theme = _ref2.theme;
  return theme.foreground;
});

exports.TrackElement = TrackElement;

var ThumbElement = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  left: 0;\n  top: ", "px;\n  display: block;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", "px;\n  background-color: ", ";\n  box-shadow: ", ";\n  border: 1px solid\n    ", ";\n  cursor: pointer;\n  transform: translate(-50%, -50%);\n  transition: box-shadow 300ms;\n  z-index: ", ";\n"])), TRACK_THICKNESS / 2, THUMB_DIAMETER, THUMB_DIAMETER, THUMB_DIAMETER / 2, function (_ref3) {
  var theme = _ref3.theme;
  return theme.background;
}, function (_ref4) {
  var theme = _ref4.theme,
      state = _ref4.state;
  if (state === 'hovered') return "0 0 0 4px ".concat((0, _polished.transparentize)(0.4, theme.primary));
  if (state === 'active') return "0 0 0 8px ".concat((0, _polished.transparentize)(0.4, theme.primary));
  return theme.shadows[1];
}, function (_ref5) {
  var theme = _ref5.theme;
  return (0, _polished.mix)(0.9, theme.background, theme.foreground);
}, function (_ref6) {
  var state = _ref6.state;
  if (state === 'hovered') return 6;
  if (state === 'active') return 7;
  return 5;
});

exports.ThumbElement = ThumbElement;

var ThumbLabelElement = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  top: -2px;\n  left: 50%;\n  transform: translate(-50%, -100%);\n"])), function (_ref7) {
  var visible = _ref7.visible;
  return visible ? 'block' : 'none';
});

exports.ThumbLabelElement = ThumbLabelElement;

var IncrementLabelElement = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 2px;\n  left: 0;\n  transform: translate(-50%, 100%);\n  z-index: 4;\n"])));

exports.IncrementLabelElement = IncrementLabelElement;

var TrackOverlayElement = _styled["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  width: 100%;\n  z-index: 2;\n  transform: translateY(-50%);\n"])), TRACK_THICKNESS / 2);

exports.TrackOverlayElement = TrackOverlayElement;

var ThumbConnectorElement = _styled["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  z-index: 3;\n  transform: translateY(-50%);\n"])), TRACK_THICKNESS / 2);

exports.ThumbConnectorElement = ThumbConnectorElement;

var useBodyEventListener = function useBodyEventListener(event, callback) {
  (0, _react.useEffect)(function () {
    document.body.addEventListener(event, callback);
    return function () {
      return document.body.removeEventListener(event, callback);
    };
  }, [event, callback]);
};
/**
 * Locks value to given min, max and step
 *
 * @param value - The value to be locked.
 * @param min - The minimun allowable value.
 * @param max - The maximum allowable value.
 * @param step - The step size.
 * @param direction - Used for when moving between values. I.e. if the value is decreasing you want to use Math.ceil
 */


var lockValue = function lockValue(value, min, max, step) {
  var direction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  if (value > max) return max;
  if (value < min) return min;
  if (direction > 0) return Math.floor(value / step) * step;
  if (direction < 0) return Math.ceil(value / step) * step;
  return Math.round(value / step) * step;
};
/**
 * Creates the thumb left offset for a given value and bound options
 *
 * @param value - The value to be used.
 * @param min - The minimum allowable value.
 * @param max - The maximum allowable value.
 * @param step - The step size.
 */


var valueToThumbLeftOffset = function valueToThumbLeftOffset(value, min, max, step) {
  var lockedValue = lockValue(value, min, max, step);
  return "".concat(100 * (lockedValue - min) / (max - min), "%");
};
/**
 * Creates the thumb elements based on the values object. The params match those from the main
 * component.
 */


var createThumbs = function createThumbs(value, min, max, step, hoveredThumb, selectedThumb, setHoveredThumb, setSelectedThumb, setInitialPosition, thumbLabelGenerator, thumbLabelComponent, showThumbLabelsOnHover) {
  var thumbEnterHandlerGenerator = function thumbEnterHandlerGenerator(thumbId) {
    return function (event) {
      if (!event.isPrimary) return;
      setHoveredThumb(thumbId);
    };
  };

  var thumbLeaveHandler = function thumbLeaveHandler(event) {
    if (!event.isPrimary) return;
    setHoveredThumb(null);
  };

  var thumbSelectHandlerGenerator = function thumbSelectHandlerGenerator(thumbId) {
    return function (event) {
      if (!event.isPrimary) return;
      var thumbValue = value[thumbId];
      if (thumbValue === null) return;
      setSelectedThumb(thumbId);
      setInitialPosition({
        thumb: thumbValue,
        pointer: event.clientX
      });
    };
  };

  return Object.entries(value).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        thumbId = _ref9[0],
        thumbValue = _ref9[1];

    var state = null;
    if (hoveredThumb === thumbId) state = 'hovered';
    if (selectedThumb === thumbId) state = 'active';
    return thumbValue !== null ? /*#__PURE__*/_react["default"].createElement(ThumbElement, {
      key: thumbId,
      style: {
        left: valueToThumbLeftOffset(thumbValue, min, max, step)
      },
      onPointerEnter: thumbEnterHandlerGenerator(thumbId),
      onPointerLeave: thumbLeaveHandler,
      onPointerDown: thumbSelectHandlerGenerator(thumbId),
      draggable: false,
      state: state
    }, thumbLabelComponent ? /*#__PURE__*/_react["default"].createElement(ThumbLabelElement, {
      visible: showThumbLabelsOnHover ? (selectedThumb || hoveredThumb) === thumbId : true
    }, /*#__PURE__*/_react["default"].createElement(thumbLabelComponent, {
      thumbId: thumbId,
      value: thumbValue
    }, null)) : null, thumbLabelGenerator && !thumbLabelComponent ? /*#__PURE__*/_react["default"].createElement(ThumbLabelElement, {
      visible: showThumbLabelsOnHover ? (selectedThumb || hoveredThumb) === thumbId : true
    }, /*#__PURE__*/_react["default"].createElement(function (_ref10) {
      var thumbId = _ref10.thumbId,
          value = _ref10.value;
      return thumbLabelGenerator(thumbId, value);
    }, {
      thumbId: thumbId,
      value: thumbValue
    }, null)) : null) : null;
  });
};
/**
 * Creates the line elements that connect the thumbs based on the values object. The params match
 * those from the main component.
 */


var createThumbConnectors = function createThumbConnectors(value, min, max, thumbConnectorComponent) {
  var orderedThumbs = Object.entries(value).sort(function (thumb1, thumb2) {
    if (thumb1[1] === null) return 1;
    if (thumb2[1] === null) return -1;
    if (thumb1[1] > thumb2[1]) return 1;
    if (thumb1[1] < thumb2[1]) return -1;
    return 0;
  });
  return orderedThumbs.map(function (_ref11, index) {
    var _ref12 = _slicedToArray(_ref11, 2),
        thumbId1 = _ref12[0],
        thumbValue1 = _ref12[1];

    if (!orderedThumbs[index + 1]) return null;

    var _orderedThumbs = _slicedToArray(orderedThumbs[index + 1], 2),
        thumbId2 = _orderedThumbs[0],
        thumbValue2 = _orderedThumbs[1];

    if (thumbValue1 === null || thumbValue2 === null) return null;

    var connector = /*#__PURE__*/_react["default"].createElement(thumbConnectorComponent, {
      thumbId1: thumbId1,
      thumbId2: thumbId2
    }, null);

    if (!connector) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(ThumbConnectorElement, {
      key: "".concat(thumbId1, "-").concat(thumbId2),
      style: {
        left: "".concat(100 * (thumbValue1 - min) / (max - min), "%"),
        width: "".concat(100 * (thumbValue2 - thumbValue1 - min) / (max - min), "%")
      }
    }, connector);
  });
};

var coerceSingleValue = function coerceSingleValue(value) {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') return parseFloat(value);
  return null;
};

var coerceValue = function coerceValue(value) {
  if (value === null || _typeof(value) !== 'object') {
    return _defineProperty({}, SINGLE_VALUE_KEY, coerceSingleValue(value));
  }

  return Object.keys(value).reduce(function (acc, key) {
    if (value[key] !== null) acc[key] = coerceSingleValue(value[key]);
    return acc;
  }, {});
};

var uncoerceSingleValue = function uncoerceSingleValue(value, type) {
  if (value === null) return null;
  if (type === 'object') return null;
  if (type === 'string') return value.toString();
  if (type === 'number') return value;
  throw Error('Invalid value for range provided.');
};

var uncoerceValue = function uncoerceValue(coercedValue, originalValue) {
  if (originalValue === null || _typeof(originalValue) !== 'object') {
    return uncoerceSingleValue(coercedValue[SINGLE_VALUE_KEY], _typeof(originalValue));
  }

  return Object.keys(coercedValue).reduce(function (acc, key) {
    acc[key] = uncoerceSingleValue(coercedValue[key], _typeof(originalValue[key]));
    return acc;
  }, {});
};
/**
 * A component to replace the html input[type=range], handles multiple thumbs and more styling
 * options like labels and increment labels.
 */


var Range = function Range(_ref14) {
  var _ref14$value = _ref14.value,
      value = _ref14$value === void 0 ? null : _ref14$value,
      _ref14$min = _ref14.min,
      min = _ref14$min === void 0 ? 0 : _ref14$min,
      _ref14$max = _ref14.max,
      max = _ref14$max === void 0 ? 100 : _ref14$max,
      _ref14$step = _ref14.step,
      step = _ref14$step === void 0 ? 1 : _ref14$step,
      onChange = _ref14.onChange,
      thumbLabelGenerator = _ref14.thumbLabelGenerator,
      thumbLabelComponent = _ref14.thumbLabelComponent,
      incrementLabelGenerator = _ref14.incrementLabelGenerator,
      incrementLabelComponent = _ref14.incrementLabelComponent,
      showThumbLabelsOnHover = _ref14.showThumbLabelsOnHover,
      incrementLabelSeparation = _ref14.incrementLabelSeparation,
      trackOverlay = _ref14.trackOverlay,
      thumbConnectorGenerator = _ref14.thumbConnectorGenerator,
      thumbConnectorComponent = _ref14.thumbConnectorComponent,
      disabled = _ref14.disabled,
      readOnly = _ref14.readOnly;
  var trackRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(coerceValue(value)),
      _useState2 = _slicedToArray(_useState, 2),
      coercedValue = _useState2[0],
      setCoercedValue = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      hoveredThumb = _useState4[0],
      setHoveredThumb = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedThumb = _useState6[0],
      setSelectedThumb = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      initialPosition = _useState8[0],
      setInitialPosition = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      readOnlyWarningSent = _useState10[0],
      setReadOnlyWarningSent = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      controlledWarningSent = _useState12[0],
      setControlledWarningSent = _useState12[1];

  var moveHandler = function moveHandler(event) {
    var _trackRef$current;

    var trackWidth = trackRef === null || trackRef === void 0 ? void 0 : (_trackRef$current = trackRef.current) === null || _trackRef$current === void 0 ? void 0 : _trackRef$current.clientWidth;
    if (!event.isPrimary || selectedThumb === null || coercedValue[selectedThumb] === null || initialPosition === null || !trackWidth) return;
    event.preventDefault();
    var newX = event.clientX;
    if (newX === null) return;
    var percentageMove = (newX - initialPosition.pointer) / trackWidth;
    var thumbNewValue = lockValue(initialPosition.thumb + percentageMove * (max - min), min, max, step, Math.sign(percentageMove));

    if (onChange && thumbNewValue !== coercedValue[selectedThumb]) {
      onChange(uncoerceValue(_objectSpread(_objectSpread({}, coercedValue), {}, _defineProperty({}, selectedThumb, thumbNewValue)), value));
    }
  };

  var clearSelection = function clearSelection(event) {
    if (!event.isPrimary) return;
    setSelectedThumb(null);
    setInitialPosition(null);
  };

  useBodyEventListener('pointerleave', clearSelection);
  useBodyEventListener('pointerup', clearSelection);
  useBodyEventListener('pointermove', moveHandler);
  (0, _react.useEffect)(function () {
    if ((value || typeof value === 'number') && !onChange && !readOnly && !readOnlyWarningSent) {
      console.warn('You provided no `onChange` prop, but provided a `value` prop. If you ' + 'are sure this component should be read-only, add the `readOnly` prop');
      setReadOnlyWarningSent(true);
    }
  }, [value, onChange, readOnly, readOnlyWarningSent]);
  (0, _react.useEffect)(function () {
    var newCoercedValue = coerceValue(value);
    var combinedKeys = new Set([].concat(_toConsumableArray(Object.keys(coercedValue)), _toConsumableArray(Object.keys(newCoercedValue))));
    var hasChanged = false;
    combinedKeys.forEach(function (thumbId) {
      var oldIsNullish = coercedValue[thumbId] == null;
      var newIsNullish = newCoercedValue[thumbId] == null;
      hasChanged = hasChanged || coercedValue[thumbId] !== newCoercedValue[thumbId];

      if (oldIsNullish && !newIsNullish && !controlledWarningSent) {
        console.warn('Looks like the type of the value prop changed from being uncontrolled to controlled; this can lead to bugs.', 'See more: https://fb.me/react-controlled-components');
        setControlledWarningSent(true);
      }

      if (!oldIsNullish && newIsNullish && !controlledWarningSent) {
        console.warn('Looks like the type of the value prop changed from being controlled to uncontrolled; this can lead to bugs.', 'See more: https://fb.me/react-controlled-components');
        setControlledWarningSent(true);
      }
    });
    if (hasChanged) setCoercedValue(newCoercedValue);
  }, [value, coercedValue, controlledWarningSent]);

  var disableScroll = function disableScroll(event) {
    return event.preventDefault();
  };

  var thumbs = createThumbs(coercedValue, min, max, step, hoveredThumb, selectedThumb, setHoveredThumb, setSelectedThumb, setInitialPosition, thumbLabelGenerator, thumbLabelComponent, showThumbLabelsOnHover);
  var thumbConnectors = null;

  if (thumbConnectorComponent) {
    thumbConnectors = createThumbConnectors(coercedValue, min, max, thumbConnectorComponent);
  }

  if (thumbConnectorGenerator && !thumbConnectorComponent) {
    thumbConnectors = createThumbConnectors(coercedValue, min, max, function (_ref15) {
      var thumbId1 = _ref15.thumbId1,
          thumbId2 = _ref15.thumbId2;
      return thumbConnectorGenerator(thumbId1, thumbId2);
    });
  }

  var incrementLabels = null;

  if (incrementLabelComponent) {
    incrementLabels = Array.from({
      length: Math.ceil((max - min) / (incrementLabelSeparation || step)) + 1
    }, function (_, index) {
      var incrementValue = index * (incrementLabelSeparation || step) + min;

      var generatedLabel = /*#__PURE__*/_react["default"].createElement(incrementLabelComponent, {
        value: incrementValue
      }, null);

      return generatedLabel ? /*#__PURE__*/_react["default"].createElement(IncrementLabelElement, {
        key: incrementValue,
        style: {
          left: "".concat(100 * (incrementValue - min) / (max - min), "%")
        }
      }, generatedLabel) : null;
    });
  } // Deprecated API


  if (incrementLabelGenerator) {
    incrementLabels = Array.from({
      length: Math.ceil((max - min) / (incrementLabelSeparation || step)) + 1
    }, function (_, index) {
      var incrementValue = index * (incrementLabelSeparation || step) + min;

      var generatedLabel = /*#__PURE__*/_react["default"].createElement(function (_ref16) {
        var value = _ref16.value;
        return incrementLabelGenerator(value);
      }, {
        value: incrementValue
      }, null);

      return generatedLabel ? /*#__PURE__*/_react["default"].createElement(IncrementLabelElement, {
        key: incrementValue,
        style: {
          left: "".concat(100 * (incrementValue - min) / (max - min), "%")
        }
      }, generatedLabel) : null;
    });
  }

  var dummyAriaValue = Object.values(coercedValue)[0];
  return /*#__PURE__*/_react["default"].createElement(RangeWraperElement, _extends({
    role: "slider",
    "aria-disabled": disabled
  }, dummyAriaValue !== null ? {
    'aria-valuenow': dummyAriaValue
  } : {}, {
    "aria-valuemin": min,
    "aria-valuemax": max,
    disableMouseEvents: disabled || readOnly,
    onTouchStart: disableScroll
  }), /*#__PURE__*/_react["default"].createElement(TrackWrapperElement, null, /*#__PURE__*/_react["default"].createElement(TrackElement, {
    ref: trackRef
  }), trackOverlay ? /*#__PURE__*/_react["default"].createElement(TrackOverlayElement, null, trackOverlay) : null, thumbConnectors, incrementLabels, thumbs));
};

var _default = Range;
exports["default"] = _default;